import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  containerClassName?: string;
}

const Input: React.FC<InputProps> = ({
  label,
  error,
  id,
  containerClassName = '',
  className = '',
  ...rest
}) => {
  return (
    <div className={`field gap-[4px] ${containerClassName}`}>
      {label && (
        <label htmlFor={id} className="field-label">
          {label}
        </label>
      )}
      <input
        id={id}
        className={`control-base ${error ? 'input-error' : ''} ${className}`.trim()}
        aria-invalid={error ? true : rest['aria-invalid']}
        {...rest}
      />
      {error && <span className="field-error">{error}</span>}
    </div>
  );
};

export default Input;
